<script lang="ts">
    import {guiCreatorDataStore} from '../../stores/guiCreatorData';
    import {HitBoxTypes, UITriangle} from './triangle';
    import ConfigInput from "../utils/ConfigTextInput.svelte";
    import {UIElement} from '../element';
    import {OriginCoords} from '../../types';
    import ConfigCheckbox from "../utils/ConfigCheckbox.svelte";
    import ConfigDropdownSelect from "../utils/ConfigDropdownSelect.svelte";
    import {isStringColorString} from "../../utils/helpers";

    export let uiElement: UITriangle;
    export let origin: OriginCoords;

    let nameValue = uiElement.name;
    let xValue = uiElement.x.toString();
    let yValue = uiElement.y.toString();
    let widthValue = uiElement.width.toString();
    let heightValue = uiElement.height.toString();
    let rotationValue = uiElement.rotation.toString();
    let colorValue = uiElement.color;
    let clickableValue = uiElement.clickable;
    let hitBoxTypeValue = uiElement.hitBoxType;
    let vibrateValue = uiElement.vibrate;
    let displayHitBoxValue = uiElement.displayHitBox;
    let hitBoxOffsetXRightValue = uiElement.hitBoxOffsetXRight;
    let hitBoxOffsetXLeftValue = uiElement.hitBoxOffsetXLeft;
    let hitBoxOffsetYTopValue = uiElement.hitBoxOffsetYTop;
    let hitBoxOffsetYBottomValue = uiElement.hitBoxOffsetYBottom;
    let groupValue = uiElement.group;
    let zValue = uiElement.z;
    let hitBoxOptions = [HitBoxTypes.RECTANGLE, HitBoxTypes.TRIANGLE]

    function onValueChange(attributeName: keyof UITriangle | keyof UIElement, parseValueToInt = true) {
        return (value) => {
            uiElement[attributeName] = parseValueToInt ? parseInt(value.detail) : value.detail;
            guiCreatorDataStore.update(uiElement);
        }
    }


</script>

<div>

    <div class="flex flex-row bg-center pt-1">
        <p class="text-lg">Infos: Triangle</p>
    </div>

    <ConfigInput value="{nameValue}" on:configValueChanged={onValueChange('name', false)} title="Name"></ConfigInput>
    <ConfigInput value="{groupValue || ''}" on:configValueChanged={onValueChange('group', false)}
                 title="Group"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Position</p>
    </div>
    <ConfigInput value="{xValue}" on:configValueChanged={onValueChange('x', true)}
                 title="X"></ConfigInput>
    <ConfigInput value="{yValue}" on:configValueChanged={onValueChange('y', true)}
                 title="Y"></ConfigInput>
    <ConfigInput value="{zValue}" on:configValueChanged={onValueChange('z', true)}
                 title="Z"></ConfigInput>
    <ConfigInput value="{rotationValue}" on:configValueChanged={onValueChange('rotation', true)}
                 title="Rotation"></ConfigInput>

    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Measurements</p>
    </div>
    <ConfigInput value="{widthValue}" on:configValueChanged={onValueChange('width', true)} title="Width"></ConfigInput>
    <ConfigInput value="{heightValue}" on:configValueChanged={onValueChange('height', true)}
                 title="Height"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Look</p>
    </div>
    <ConfigInput value="{colorValue}" validator="{isStringColorString}"
                 on:configValueChanged={onValueChange('color', false)} title="Color"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">Interaction</p>
    </div>
    <ConfigCheckbox value="{clickableValue}"
                    on:configValueChanged={onValueChange('clickable', false)} title="Clickable"></ConfigCheckbox>
    <ConfigCheckbox value="{displayHitBoxValue}"
                    on:configValueChanged={onValueChange('displayHitBox', false)} title="Show Hitbox"></ConfigCheckbox>
    <ConfigDropdownSelect value="{hitBoxTypeValue}" options="{hitBoxOptions}"
                          on:configValueChanged={onValueChange('hitBoxType', false)}
                          title="Hit box type"></ConfigDropdownSelect>
    <ConfigInput value="{hitBoxOffsetXLeftValue}" active="{hitBoxTypeValue === HitBoxTypes.RECTANGLE}"
                 on:configValueChanged={onValueChange('hitBoxOffsetXLeft', true)}
                 title="HitBox X left offset"></ConfigInput>
    <ConfigInput value="{hitBoxOffsetXRightValue}" active="{hitBoxTypeValue === HitBoxTypes.RECTANGLE}"
                 on:configValueChanged={onValueChange('hitBoxOffsetXRight', true)}
                 title="HitBox X right offset"></ConfigInput>
    <ConfigInput value="{hitBoxOffsetYTopValue}" active="{hitBoxTypeValue === HitBoxTypes.RECTANGLE}"
                 on:configValueChanged={onValueChange('hitBoxOffsetYTop', true)}
                 title="HitBox Y top offset"></ConfigInput>
    <ConfigInput value="{hitBoxOffsetYBottomValue}" active="{hitBoxTypeValue === HitBoxTypes.RECTANGLE}"
                 on:configValueChanged={onValueChange('hitBoxOffsetYBottom', true)}
                 title="HitBox Y bottom offset"></ConfigInput>
    <div class="flex flex-row bg-center text-input-combination pt-1">
        <p class="text-lg">OnTap</p>
    </div>
    <ConfigCheckbox value="{vibrateValue}" title="Vibrate on Click"
                    on:configValueChanged={onValueChange('vibrate', false)}></ConfigCheckbox>

</div>

<style>

    .text-input-combination {
        border-style: dashed;

        display: grid;
        grid-template-columns: 60px 80%;
    }
</style>
